export const USER_TYPE_HOST = 'host';
export const USER_TYPE_ADVERTISER = 'advertiser';
